import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { getConfig } from './lib/runtimeConfig.js';
import './styles.css';

Sentry.init({
  dsn: getConfig('SENTRY_DSN', import.meta.env.VITE_SENTRY_DSN),
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById('root')).render(<App />);
